var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-list-table-view" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-table",
            {
              staticClass: "table edit",
              attrs: {
                data: _vm.list,
                "header-cell-style": {
                  background: "rgb(48, 65, 86)",
                  color: "white"
                },
                "cell-style": _vm.getCellClassStyle
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  "class-name": "action",
                  width: "80px",
                  align: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("i", {
                          staticClass: "action-item el-icon-remove-outline",
                          on: {
                            click: function($event) {
                              return _vm.onRemoveField(scope.row)
                            }
                          }
                        }),
                        _c("i", {
                          staticClass:
                            "action-item el-icon-circle-plus-outline",
                          on: {
                            click: function($event) {
                              return _vm.onAddField(scope.row)
                            }
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: _vm.$t("Name"), width: "240px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.$t("Name"),
                            "suffix-icon": "el-icon-edit"
                          },
                          on: {
                            change: function($event) {
                              return _vm.onChange(scope.row)
                            }
                          },
                          model: {
                            value: scope.row.name,
                            callback: function($$v) {
                              _vm.$set(scope.row, "name", $$v)
                            },
                            expression: "scope.row.name"
                          }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("Value"),
                  width: "auto",
                  "min-width": "120px"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("el-input", {
                          attrs: {
                            placeholder: _vm.$t("Value"),
                            "suffix-icon": "el-icon-edit"
                          },
                          on: {
                            change: function($event) {
                              return _vm.onChange(scope.row)
                            }
                          },
                          model: {
                            value: scope.row.value,
                            callback: function($$v) {
                              _vm.$set(scope.row, "value", $$v)
                            },
                            expression: "scope.row.value"
                          }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }